import {Configuration, DefaultApi, type Middleware} from "~/models";
const doNotTrackErrorsON = [
    '/api/auth/session',
    '/api/auth/token',
]

// silent=true — не чіпати глобальний NuxtLoadingIndicator (верхня смуга).
// Для фонових запитів мапи, де прогрес показуємо локально (напр. збереження позиції літака).
export const useApi = (opts?: {silent?: boolean}) => {
    const {showApiError} = useApiErrors()
    const {start, finish} = useLoadingIndicator()
    const silent = opts?.silent ?? false

    return new DefaultApi(new Configuration({
        basePath: '',
        middleware: [
            {
                pre: (context) => {
                    if (!silent) start()
                },
            } as Middleware,
            {
                post: (context) => {
                    if (!silent) finish()

                    if (context.response.ok) {
                        return
                    }

                    if (!doNotTrackErrorsON.includes(context.url)) {
                        showApiError(context.response.status, context.response)
                    }
                },
            } as Middleware
        ]
    }))
}